const s = {
  name: "Talk",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,18.7,21.3,19.3,21.3,20z"
			/>
		<path class="st0" d="M15,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C13.8,20.7,14.3,21.2,15,21.2z"
			/>
		<path class="st0" d="M26.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C25.7,18.7,26.3,19.3,26.3,20z"
			/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,4.1,1.2,7.8,3.3,11l-2.9,8.6L9,36.7c3.1,2.1,6.9,3.3,11,3.3c11,0,20-9,20-20
			C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18s18,8.1,18,18s-8.1,18-18,18c-3.8,0-7.3-1.2-10.2-3.2l-0.4-0.3l-5.8,1.9l1.9-5.8
			l-0.3-0.4C3.2,27.3,2,23.8,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Talk
};
